import React from 'react';

import Card from 'components/DesignSystem/Card';
import SubsistemaChart from 'components/Relatorios/Dessem/secoes/VisaoGeral/SubsistemaChart';
import SecaoDessemEstado from 'components/Relatorios/Dessem/secoes/shared/SecaoDessemEstado';

import { DARK_BLUE, MEDIUM_BLUE } from 'constants/colors';
import useDessemSecaoParams from 'hooks/Relatorios/Dessem/useDessemSecaoParams';
import { useGetDessemVisaoGeralQuery } from 'services/api/products/relatorios';

import './index.scss';

// tema: dados-inicio — cor de subsistema
// NE/N não têm correspondente exato em constants/colors (paleta é toda em
// tons de azul); ciano/verde-água aproximam o Figma (subsistemas NE/N).
const CIANO = '#1AC8D6';
const VERDE_AGUA = '#BFEEE3';

const CORES_SUBSISTEMA: Record<string, string> = {
  'SE/CO': DARK_BLUE,
  S: MEDIUM_BLUE,
  NE: CIANO,
  N: VERDE_AGUA,
};
// tema: dados-fim

export default function VisaoGeral() {
  const params = useDessemSecaoParams();

  const resultado = useGetDessemVisaoGeralQuery(params);

  return (
    <SecaoDessemEstado resultado={resultado} params={params}>
      {(data) => (
        <Card title={data.titulo}>
          {/* A data (e o cenário) ficam na faixa de contexto do `SecaoDessemEstado`, acima
              do card; o cabeçalho não a repete. */}
          <div className="dessem-visao-geral__header">
            <div className="dessem-visao-geral__contingencia">
              {`Nível de Contingência: ${data.nivel_contingencia}`}
            </div>
          </div>
          {data.subsistemas.map((subsistema) => (
            <SubsistemaChart
              key={subsistema.sigla}
              subsistema={subsistema}
              periodos={data.periodos}
              cor={CORES_SUBSISTEMA[subsistema.sigla] ?? DARK_BLUE} // tema: cor de dado
            />
          ))}
        </Card>
      )}
    </SecaoDessemEstado>
  );
}
